import { styled } from "goober";
import type { ReactNode } from "react";
import { Text } from "../Text";

// Shared cells for monitoring lists rendered with <ListTable> (the Overview
// table and the panel drill-in modals), so they match the rest of the app's
// list style (members, connectors, …).

export const NameCell = styled("div")`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const NameBody = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ScrollArea = styled("div")`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

// Outer surface-secondary container framing a modal list section — a heading
// plus a white list nested inside, inset by the container's padding. Mirrors
// the settings modals (connector access, member detail), where each section is
// a secondary card holding a primary-surface list.
export const ListCard = styled("div")`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  background: var(--surface-secondary);
  border: 0.5px solid var(--border-alpha);
  border-radius: 16px;
`;

export const ListCardHeader = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 8px;
`;

export const ListCardHeading = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const TableCard = styled("div")`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--surface-primary);
  border: 0.5px solid var(--border-alpha);
  border-radius: 12px;
  overflow: hidden;
`;

export function ListSection({
  title,
  description,
  action,
  children,
}: {
  title: string;
  description: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <ListCard>
      <ListCardHeader>
        <ListCardHeading>
          <Text variant="text-regular-md">{title}</Text>
          <Text variant="text-small" color="var(--text-secondary)">
            {description}
          </Text>
        </ListCardHeading>
        {action}
      </ListCardHeader>
      <TableCard>
        <ScrollArea>{children}</ScrollArea>
      </TableCard>
    </ListCard>
  );
}
